function Todo() {
  return (
    <div className="card">
      <h2>TITLE</h2>
      <div className="actions">
        <button className="btn">Ta bort</button>
      </div>
    </div>
  );
}

export default Todo;
